import t from "../../../helpers/t";
import React from "react";
import Biscuit from "../../../../utils/Biscuit";
import {_, moment} from "../../../../../vendor";

const ResourcesPanel = (props) => {
    const {contingent} = props;
    const getNumbersByDay = (day) => {

        if (typeof day === 'string') {
            day = moment(day);
        }

        let result;

        _.each(contingent.contingent_numbers, function(numberObj, __) {

            const valid_from = moment(numberObj.valid_from);

            if (valid_from.isSameOrBefore(day)) {
                if (typeof result !== 'undefined') {
                    // Compare with previous valid_from
                    if (moment(result.valid_from).isAfter(valid_from)) {
                        return;
                    }
                }

                result = numberObj;
            }
        });

        return result;
    }
    const contingent_numbers = getNumbersByDay(moment());
    const number_active = (typeof contingent_numbers !== 'undefined' ? contingent_numbers.number : 0);
    return(
        <>

            <div className={"inb-contingent-progress"}
                 style={{marginBottom: "-1rem"}}>
                    <>
                        <div className="progress beautify" role="progressbar" tabIndex="0"
                             aria-valuenow="50" aria-valuemin="0" aria-valuetext="50 percent" aria-valuemax="100">
                        <div className="progress-bars">
                            {/*<span className="progress-meter" style={{width: "100%"}}> </span>*/}
                        </div>
                        <p className="progress-meter-text">
                            {number_active  + " " + contingent.name + " " + t('bookable')}
                            {/* +t((contingent.resourcetype_id === 4 ? 'participants_bookable' : 'vehicles_active'))*/}
                        </p>
                        </div>
                    </>
                </div>
        </>
    )
}
export default ResourcesPanel;